import { useState, useEffect } from 'react'

// disable default browser validation when JS is enable
// but keeps it when JS is disabled
export function useNoValidate() {
  const [noValidate, setNoValidate] = useState(false)
  useEffect(() => {
    setNoValidate(true)
  }, [])
  return noValidate
}
